import { render, staticRenderFns } from "./SettingsWorkflow.vue?vue&type=template&id=b89c46e8&"
import script from "./SettingsWorkflow.vue?vue&type=script&lang=ts&"
export * from "./SettingsWorkflow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports